import { render, staticRenderFns } from "./CustomSzwtProcessPointsModal.vue?vue&type=template&id=b4eb4adc&"
import script from "./CustomSzwtProcessPointsModal.vue?vue&type=script&lang=js&"
export * from "./CustomSzwtProcessPointsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports